export default __webpack_public_path__ + "static/media/infra-icon.ba827925.svg";